export default __webpack_public_path__ + "media/images/borders/white-border-cleaned-sides-3501b64bf848bfa41057907887552856.svg";